module.exports = __webpack_public_path__ + "static/pavlo_chervinskyy-f259dcdfd621df38894e97cad50fcea2.png";